import { type AnalyticsPlugin } from 'analytics';

import { type AnalyticsEvent } from '@automation-suite/shared-clients-analytics-dispatcher';

declare global {
  interface Window {
    dataLayer: {
      push(event: { [key: string]: unknown; event: string }): void;
    };
  }
}

export const googleAnalyticsPlugin: AnalyticsPlugin = {
  name: 'google-analytics',
  track: (event: AnalyticsEvent) => {
    event.payload.properties.MetaData.DispatchedBy = 'SIN-GoogleAnalyticsPlugin';

    if (typeof window.dataLayer !== 'undefined') {
      window.dataLayer.push({
        event: event.payload.properties.Name,
        ...event.payload.properties,
      });
    }
  },
};
